'use client'
import { switchLanguages } from '@little-tavern/shared/src/i18n/settings'
import IconLang from '@little-tavern/shared/src/ui/icon/lang'
import { ChevronDown } from 'lucide-react'
import { usePathname, useParams } from 'next/navigation'
import { useTranslation } from 'react-i18next'
import React, { useContext } from 'react'
import change from '@/app/module/changeLang'
import useRequest from '@little-tavern/shared/src/hook/useRequest'
import { AuthContext } from '@little-tavern/shared/src/authContext'

const LangSwitch = ({className = ''}: {className?: string}) => {
    const { t, i18n } = useTranslation()
    const lang = i18n.language
    const pathname = usePathname()
    const params = useParams()
    const request = useRequest();
    const auth = useContext(AuthContext);
    const isLogin = auth?.isLogin;
    const setLang = (e: any) => {
        change(e.target.value, pathname, params.lang as string, request, auth, t, isLogin)
    }
    return <>
    {switchLanguages.length > 1 && <div className={`${className} flex text-sm items-center py-4 px-1.5 sm:py-0 sm:px-0 relative text-zinc-500 sm:text-purple-950 dark:sm:text-white`}>
        <IconLang className='w-7 h-7 mr-0.5 sm:hidden' />
        <div className='hidden sm:flex items-center justify-between min-w-[96px] h-8 px-3 rounded-full bg-purple-950/10 dark:bg-white/15 text-sm leading-none'>
            <span>{t(`app.lang.${lang}`)}</span>
            <ChevronDown className='w-4 h-4 ml-2 shrink-0' />
        </div>
        <select className='text-center bg-white dark:bg-black dark:text-white sm:bg-transparent sm:dark:bg-transparent w-full h-full absolute opacity-0 left-0 top-0 cursor-pointer' value={lang} onChange={setLang}>
            {switchLanguages.map((l) => {
                return (
                    <option key={l} value={l}>{t(`app.lang.${l}`)}</option>
                )
            })}
        </select>
    </div>}
    </>
}

export default LangSwitch